import boostModelFairnessIcon from '../../../public/svg/icons/synthetic-data/boost-model-fairness.svg';
import costAndTimeEfficiencyIcon from '../../../public/svg/icons/synthetic-data/cost-and-time-efficiency.svg';
import fillTheDataGapsIcon from '../../../public/svg/icons/synthetic-data/fill-the-data-gaps.svg';
import privacyFirstInnovationIcon from '../../../public/svg/icons/synthetic-data/privacy-first-innovation.svg';
import unlimitedScaleIcon from '../../../public/svg/icons/synthetic-data/unlimited-scale.svg';

export const benefitsData = {
  title: 'Benefits of using synthetic data in your projects',
  items: [
    {
      title: 'Privacy-First Innovation',
      description:
        'Generate unlimited training data without exposing real customer information or violating regulations.',
      icon: privacyFirstInnovationIcon,
    },
    {
      title: 'Cost & Time Efficiency',
      description:
        'Synthetic datasets can be synthesized through computer simulations or generative models, making them cheaper to produce on demand than collecting and labeling real data.',
      icon: costAndTimeEfficiencyIcon,
    },
    {
      title: 'Fill the Data Gaps',
      description:
        'When information is sparse, synthetic data can fill in the gaps, especially for rare events like fraud or edge cases.',
      icon: fillTheDataGapsIcon,
    },
    {
      title: 'Unlimited Scale',
      description: `Synthetic data can be produced in nearly limitless volumes and customized to an organization's needs.`,
      icon: unlimitedScaleIcon,
    },
    {
      title: 'Boost Model Fairness',
      description:
        'Synthetic data can be used to boost data diversity, especially for underrepresented groups in AI model training.',
      icon: boostModelFairnessIcon,
    },
  ],
};
